import { TICKET_TYPES } from '../enum/ticketTypes';
import { TranslationSvc } from '../services/translation.service';

class Ticket {

    /** @constructor */

    constructor(){
        this.ticket = ''
    }

    /**
     * Create ticket
     * @returns {Array}
     */

    create() {

        let ticketConfig = {
                tickets:[
                    {
                        useTicketLocalStorage: true,
                        doTicketStatusCheck: true,
                        pendingTicketLimitTotal: 100,
                        pendingTicketLimitByGame: 1,
                        pendingTicketCheckInterval: 10000,
                        pendingTicketRejectPeriod: 30000,
                        sentTicketRejectPeriod: 10000,
                    }
                ]
            },
            tickets = [];

        for (let i = 0; i < ticketConfig.tickets.length; i++) {

            tickets.push({
                id: TICKET_TYPES.SINGLE.name,
                active: true,
                ticketGroup: 'Keno',
                betsCollection: 'Keno',
                group: {
                    id: 'Keno',
                    taxesConfig: sevenConfig.data.config.taxes
                },
                ticketType: TICKET_TYPES.SINGLE,
                oddProp: 'mboOddValue',
                stakeTouched: false,
                setStakeStrategy: 'sevenVirtualSetStake',
                winningStrategy: false,
                autoStakeSetting: true,
                setFormatPayin: 'sevenVirtualFormataPayin',
                hasSystem: false,
                emptyBetslipText: TranslationSvc.getTranslation('empty_betslip_message'),
                betTemplate: 'virtual'
            });
        }


        return tickets;

    }

    /**
     * Reset ticket
     */

    resetTicket(){
        this.ticket = '';
    }


}

export default  Ticket;



// WEBPACK FOOTER //
// ticket.js